import {Injectable} from "@angular/core";
import {HttpClient} from "@angular/common/http";
import {FormDataRequestService} from "ngx-auth-util-lib";
import {Observable} from "rxjs";
import {environment} from "../../../environments/local/environment";
import {OmsDetectorDataEntry} from "../../models/oms-detector-data-entry";
import {OmsValidateKeyDataResponse} from "../../models/responses/oms-validate-key-data-response";
import {OmsValidateKeyDataRequest} from "../../models/requests/oms-validate-key-data-request";
import {OmsDownloadHistoryResponse} from "../../models/responses/oms-download-history-response";
import {OmsDownloadHistoryRequest} from "../../models/requests/oms-download-history-request";
import {OmsKeyDownloadService} from "./oms-key-download.service";

@Injectable({
  providedIn: 'root'
})
export class OmsKeyDownloadServiceImpl extends OmsKeyDownloadService {

  exportRedirectUrl = environment.redirect.host + '/pages/keys';

  constructor(
    private httpClient: HttpClient,
    private formDataRequestService: FormDataRequestService
  ) {
    super();
  }

  public override validateKeyData(entries: OmsDetectorDataEntry[]): Observable<OmsValidateKeyDataResponse> {
    const request: OmsValidateKeyDataRequest = {
      entries: entries
    }

    const url = environment.backend.endpoint.host +
      environment.oms.endpoint.paths.prefix +
      environment.oms.endpoint.paths.validate

    return this.httpClient.post<OmsValidateKeyDataResponse>(url, request);
  }

  override requestHistoryEntriesByOrderNumber(orderNumber: string): Observable<OmsDownloadHistoryResponse> {
    const url = environment.backend.endpoint.host +
      environment.oms.endpoint.paths.prefix +
      environment.oms.endpoint.paths.history +
      `?orderNumber=${orderNumber}`;

    return this.httpClient.get<OmsDownloadHistoryResponse>(url);
  }

  public override requestHistoryEntriesBySerialNumbers(serialNumbers: string[]): Observable<OmsDownloadHistoryResponse> {
    const request: OmsDownloadHistoryRequest = {
      serialNumbers: serialNumbers
    }

    const url = environment.backend.endpoint.host +
      environment.oms.endpoint.paths.prefix +
      environment.oms.endpoint.paths.history

    return this.httpClient.post<OmsDownloadHistoryResponse>(url, request);
  }

  public override downloadCsvFileByOrderNumber(friendlyCaptchaResponse: string, orderNumber: string) {
    const url = environment.backend.endpoint.host +
      environment.oms.endpoint.paths.prefix +
      environment.oms.endpoint.paths.export +
      environment.oms.endpoint.paths.csv +
      environment.oms.endpoint.paths.order +
      `?orderNumber=${orderNumber}`;

    this.downloadCsvFile(url, friendlyCaptchaResponse);
  }

  public override downloadCsvFileBySerialNumbers(friendlyCaptchaResponse: string, serialNumbers: string[]) {
    if (serialNumbers.length == 0) {
      return
    }

    const serialNumberParameters = serialNumbers.map(serialNumber => `serialNumber=${serialNumber}`).join("&")

    const url = environment.backend.endpoint.host +
      environment.oms.endpoint.paths.prefix +
      environment.oms.endpoint.paths.export +
      environment.oms.endpoint.paths.csv +
      environment.oms.endpoint.paths.serialnumber +
      `?${serialNumberParameters}`;

    this.downloadCsvFile(url, friendlyCaptchaResponse);
  }

  private downloadCsvFile(url: string, friendlyCaptchaResponse: string) {
    let params: { [key: string]: any } = {
      "redirect": this.exportRedirectUrl,
      "friendlyCaptchaResponse": friendlyCaptchaResponse
    };
    this.formDataRequestService.sendRequestWithAuth(url, params, false, 'post');
  }
}
